export default [
  {
    path: '/ptn',
    name: 'manajemen-ptn',
    meta: {
      pageTitle: 'Manajemen PTN',
      breadcrumb: [
        {
          text: 'PTN',
          active: true,
        },
      ],
    },
    component: () => import('@/views/dashboard/manajemen-ptn/Ptn.vue'),
  },
  {
    path: '/ptn/:id',
    name: 'manajemen-prodi',
    meta: {
      pageTitle: 'Manajemen Prodi',
      breadcrumb: [
        {
          text: 'PTN',
          active: false,
          to: { path: '/ptn' },
        },
        {
          text: 'Prodi',
          active: true,
        },
      ],
    },
    component: () => import('@/views/dashboard/manajemen-ptn/Prodi.vue'),
  },
  {
    path: '/ptn/:id_ptn/prodi/:id_prodi',
    name: 'manajemen-prodi-detail',
    meta: {
      pageTitle: 'Detail Prodi',
      breadcrumb: [
        {
          text: 'PTN',
          active: false,
          to: { path: '/ptn' },
        },
        {
          text: 'Prodi',
          active: false,
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
    },
    component: () => import('@/views/dashboard/manajemen-ptn/ProdiDetail.vue'),
  },
]
